import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from "@chakra-ui/image";
import logoImageSrc from "./logo.svg";
const Logo = () => {
    return _jsx(Image, { src: logoImageSrc });
};
export default Logo;
